/* HH stepper v1 (2026-11-02). Progressive enhancement over the hobby-mode steps that hh-mode.js renders
   into [data-hh-steps-mode] (<article class="step" id="hm-N">). Adds a tab bar (1-7), shows ONE step at a time
   as a panel (callouts left, product grid right), prev/next, "Show all steps". If this file fails, the old layout stays.
   Touches no data and no other script. Deep links #hm-1..#hm-7 activate the matching step. */
(function () {
  'use strict';
  if (/[?&]stepper=0(&|$)/.test(location.search)) return;
  var SEC = document.querySelector('[data-hh-steps-mode]');
  if (!SEC || !('MutationObserver' in window) || !Element.prototype.closest) return;
  var root = SEC.closest('section') || SEC.parentNode;
  var RM = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: true };
  var bar, tabs, allBtn, nav, cur = 1, first = null, pendingHash = true;
  root.classList.add('hh-st-js');
  /* sticky needs no scroll container in between: .hh uses overflow-x:hidden (computes overflow-y:auto); clip keeps the same visual result */
  (function () { var e = root.parentElement; while (e && e !== document.body) { var c = getComputedStyle(e); if ((c.overflowX === 'hidden' || c.overflowY === 'hidden' || c.overflowY === 'auto') && !e.matches('html,body')) { if (CSS.supports && CSS.supports('overflow', 'clip')) e.style.overflow = 'clip'; } e = e.parentElement; } })();

  function steps() {
    var out = [], c = SEC.children;
    for (var i = 0; i < c.length; i++) if (c[i].tagName === 'ARTICLE' && /^hm-\d+$/.test(c[i].id)) out.push(c[i]);
    return out;
  }
  function txt(el) { return el ? el.textContent.trim() : ''; }
  function stepName(a) { var h = a.querySelector('h3'); if (!h) return ''; var c = h.cloneNode(true), v = c.querySelector('.vh'); if (v) v.remove(); return txt(c); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

  function stickyTop() {
    var h = document.querySelector('.cc-header--sticky') || document.querySelector('.cc-header');
    if (!h) return 0;
    var p = getComputedStyle(h).position;
    if (p !== 'sticky' && p !== 'fixed') return 0;
    var b = h.getBoundingClientRect().bottom;
    return b > 0 && b < innerHeight / 2 ? Math.round(b) : 0;
  }
  var raf = 0;
  function syncTop() {
    raf = 0;
    root.style.setProperty('--hh-st-top', stickyTop() + 'px');
    if (bar) root.style.setProperty('--hh-st-bar', bar.offsetHeight + 'px');
  }
  function onScroll() { if (!raf) raf = requestAnimationFrame(syncTop); }

  /* restructure one article: info column + shop column (nodes are moved, never recreated) */
  function shape(a, i, n) {
    if (a.__st) return;
    a.__st = 1;
    var info = document.createElement('div'), shop = document.createElement('div');
    info.className = 'st-info'; shop.className = 'st-shop';
    var kids = Array.prototype.slice.call(a.children);
    kids.forEach(function (k) {
      if (k.matches('.s-need,.gapc,.fine')) shop.appendChild(k); else info.appendChild(k);
    });
    var of = document.createElement('p');
    of.className = 'st-of'; of.setAttribute('aria-hidden', 'true');
    of.textContent = 'Step ' + (i + 1) + ' of ' + n;
    info.insertBefore(of, info.firstChild);
    if (!shop.querySelector('.sp')) {
      var fine = shop.querySelector('.fine');
      if (fine) fine.classList.add('st-empty');
    }
    a.appendChild(info); a.appendChild(shop);
    a.setAttribute('role', 'tabpanel');
    a.setAttribute('tabindex', '-1');
  }

  function build() {
    var st = steps();
    if (!st.length) { if (bar) bar.hidden = true; if (nav) nav.hidden = true; root.classList.remove('hh-st-on'); SEC.style.removeProperty('display'); SEC.style.removeProperty('grid-template-columns'); return; }
    if (st[0] === first && bar && bar.isConnected) { vis(); return; }
    first = st[0];
    var n = st.length;
    st.forEach(function (a, i) { shape(a, i, n); });
    if (!bar) {
      bar = document.createElement('div'); bar.className = 'st-bar';
      bar.innerHTML = '<div class="st-tabs" role="tablist" aria-label="Build steps"></div>' +
        '<button class="st-all" type="button" aria-pressed="false"><span>Show all steps</span></button>';
      tabs = bar.firstChild; allBtn = bar.lastChild;
      SEC.parentNode.insertBefore(bar, SEC);
      nav = document.createElement('div'); nav.className = 'st-nav';
      SEC.parentNode.insertBefore(nav, SEC.nextSibling);
      tabs.addEventListener('click', function (e) { var t = e.target.closest('[role=tab]'); if (t) go(+t.dataset.n, { scroll: true }); });
      tabs.addEventListener('keydown', key);
      nav.addEventListener('click', function (e) { var b = e.target.closest('[data-st-go]'); if (b) go(+b.dataset.stGo, { scroll: true, focusPanel: true }); });
      allBtn.addEventListener('click', function () { setAll(!root.classList.contains('st-all')); });
    }
    tabs.innerHTML = st.map(function (a, i) {
      var k = a.querySelectorAll('.sp').length;
      return '<button type="button" role="tab" class="st-tab" id="hhst-t' + (i + 1) + '" data-n="' + (i + 1) + '" aria-controls="' + a.id +
        '" aria-selected="false" tabindex="-1"><span class="st-n" aria-hidden="true">' + (i + 1) + '</span><span class="st-l"><span class="vh">Step ' + (i + 1) + ': </span>' +
        esc(stepName(a)) + '</span><span class="st-c">' + (k ? k + (k === 1 ? ' tool' : ' tools') : 'Nothing to buy') + '</span></button>';
    }).join('');
    root.classList.add('hh-st-on');
    var m = /^#hm-(\d+)$/.exec(location.hash), want = m && +m[1] <= n ? +m[1] : 1;
    go(want, { scroll: pendingHash && !!m, instant: true });
    pendingHash = false;
    vis();
    syncTop();
  }
  function vis() {
    var off = SEC.hidden || !steps().length;
    if (bar) bar.hidden = off;
    /* older '.hh .steps' grid rule (4 columns) out-ranks the stylesheet: force a plain block container while the stepper is on */
    if (off) { SEC.style.removeProperty('display'); SEC.style.removeProperty('grid-template-columns'); } else { SEC.style.setProperty('display', 'block', 'important'); SEC.style.setProperty('grid-template-columns', 'none', 'important'); }
    if (nav) nav.hidden = off || root.classList.contains('st-all');
  }

  function go(k, o) {
    o = o || {};
    var st = steps(), n = st.length;
    if (!n) return;
    k = Math.max(1, Math.min(n, k || 1));
    cur = k;
    st.forEach(function (a, i) { a.classList.toggle('st-on', i + 1 === k); });
    var t = tabs.querySelectorAll('[role=tab]');
    for (var i = 0; i < t.length; i++) {
      var on = i + 1 === k;
      t[i].setAttribute('aria-selected', on ? 'true' : 'false');
      t[i].tabIndex = on ? 0 : -1;
    }
    center(o.instant);
    var p = st[k - 2], q = st[k];
    nav.innerHTML = (p ? '<button type="button" class="btn st-prev" data-st-go="' + (k - 1) + '"><span aria-hidden="true">&larr;</span> <span><small>Step ' + (k - 1) + '</small>' + esc(stepName(p)) + '</span></button>' : '<span></span>') +
      (q ? '<button type="button" class="btn st-next" data-st-go="' + (k + 1) + '"><span><small>Next: step ' + (k + 1) + '</small>' + esc(stepName(q)) + '</span> <span aria-hidden="true">&rarr;</span></button>' : '<span></span>');
    if (root.classList.contains('st-all')) { if (o.scroll) jump(st[k - 1], o.instant); return; }
    if (o.scroll) toTop(o.instant);
    if (o.focusPanel) try { st[k - 1].focus({ preventScroll: true }); } catch (e) {}
  }
  function center(instant) {
    if (!tabs) return;
    var at = tabs.querySelectorAll('.st-tab')[cur - 1];
    if (!at || tabs.scrollWidth <= tabs.clientWidth) return;
    var left = at.offsetLeft - tabs.offsetLeft - (tabs.clientWidth - at.offsetWidth) / 2;
    try { tabs.scrollTo({ left: left, behavior: instant || RM.matches ? 'auto' : 'smooth' }); } catch (e) { tabs.scrollLeft = left; }
  }
  /* keep the bar where the eye is: if the reader is below the panel start, bring the panel start up under the bar */
  function toTop(instant) {
    syncTop();
    var y = SEC.getBoundingClientRect().top - stickyTop() - bar.offsetHeight - 8;
    if (y < 0 || y > innerHeight * 0.6) window.scrollTo({ top: Math.max(0, scrollY + y), behavior: instant || RM.matches ? 'auto' : 'smooth' });
  }
  function jump(a, instant) {
    syncTop();
    var y = a.getBoundingClientRect().top - stickyTop() - bar.offsetHeight - 8;
    window.scrollTo({ top: Math.max(0, scrollY + y), behavior: instant || RM.matches ? 'auto' : 'smooth' });
  }
  function key(e) {
    var t = tabs.querySelectorAll('[role=tab]'), n = t.length, k = cur;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') k = k % n + 1;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') k = (k + n - 2) % n + 1;
    else if (e.key === 'Home') k = 1;
    else if (e.key === 'End') k = n;
    else return;
    e.preventDefault();
    go(k, {});
    t[k - 1].focus();
  }
  function setAll(on) {
    root.classList.toggle('st-all', on);
    allBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    allBtn.firstChild.textContent = on ? 'One step at a time' : 'Show all steps';
    tabs.setAttribute('role', on ? 'list' : 'tablist');
    var t = tabs.querySelectorAll('.st-tab');
    for (var i = 0; i < t.length; i++) { t[i].setAttribute('role', on ? 'link' : 'tab'); if (on) { t[i].removeAttribute('aria-selected'); t[i].tabIndex = 0; } }
    steps().forEach(function (a) { if (on) a.removeAttribute('role'); else a.setAttribute('role', 'tabpanel'); });
    if (!on) go(cur, { scroll: true, instant: true });
    vis();
    syncTop();
  }

  /* #hm-N links (hero legend etc.): activate in capture phase so the default anchor scroll lands on a visible panel */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#hm-"]');
    if (!a || !root.classList.contains('hh-st-on')) return;
    var m = /#hm-(\d+)$/.exec(a.getAttribute('href') || '');
    if (!m || !document.getElementById('hm-' + m[1]) || !SEC.contains(document.getElementById('hm-' + m[1]))) return;
    go(+m[1], {});
  }, true);
  window.addEventListener('hashchange', function () {
    var m = /^#hm-(\d+)$/.exec(location.hash);
    if (m && root.classList.contains('hh-st-on') && document.getElementById('hm-' + m[1])) { go(+m[1], {}); jump(document.getElementById('hm-' + m[1]), true); }
  });
  window.addEventListener('beforeprint', function () { root.classList.add('st-print'); });
  window.addEventListener('afterprint', function () { root.classList.remove('st-print'); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { onScroll(); clearTimeout(center.t); center.t = setTimeout(function () { center(true); }, 150); }, { passive: true });

  new MutationObserver(function (ms) {
    var rebuild = false;
    ms.forEach(function (m) { if (m.type === 'childList') rebuild = true; });
    if (rebuild) build(); else vis();
  }).observe(SEC, { childList: true, attributes: true, attributeFilter: ['hidden'] });
  build();
  window.HHStepper = { go: go, all: setAll, rebuild: function () { first = null; build(); } };
})();
